import React from "react";
import "./Header.css";
import HeaderMenu from "./HeaderMenu";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="menu-header" role="banner">
      <div className="header-content">
        <Link to="/" className="logo-container" aria-label="Benson Dental Studio - Go to homepage">
          <img
            alt="Benson Dental Studio logo"
            className="logo-img"
            src="/benson-logo.png"
          />
        </Link>
        <HeaderMenu />
      </div>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
    </header>
  );
};

export default Header;
